import moment from 'moment';

/**
 *  Originally, defaultRanges was being imported from the '@novus-health/react-date-range' library which can be found here:
 *      https://github.com/Adphorus/react-date-range/blob/v0/src/defaultRanges.js
 *  As we needed to make changes to the logic of the program (specifically for 'Last 7 Days' and 'Last 30 Days'), this
 *      module was created and will be used
 */

const defaultRanges = {
  Today: {
    startDate: (now) => {
      return now;
    },
    endDate: (now) => {
      return now;
    }
  },
  Yesterday: {
    startDate: (now) => {
      return now.add(-1, 'days');
    },
    endDate: (now) => {
      return now.add(-1, 'days');
    }
  },
  'Last 7 Days': {
    startDate: (now) => {
      return now.add(-7, 'days');
    },
    endDate: (now) => {
      return now.add(-1, 'days');
    }
  },
  'Last 30 Days': {
    startDate: (now) => {
      return now.add(-30, 'days');
    },
    endDate: (now) => {
      return now.add(-1, 'days');
    }
  }
};

/*
 * For some unknown reason, Moment.js sets the locale automatically to the last
 * import used. To overcome this issue, I simply set the locale to 'en'
 * directly afterword. If this isn't done, then the month names always display
 * in French, regardless of the language selected. I'm not the only one that's
 * experienced this/I'm not (entirely) crazy:
 * https://stackoverflow.com/questions/50506389/moment-auto-set-locale-after-importing-the-data
 */
moment.locale('en');

const isSameDay = (range, startEnd, date) =>
  defaultRanges[range][startEnd](moment()).isSame(date, 'day');

export const isInRange = (start, end) =>
  Object.keys(defaultRanges).find(
    (key) =>
      isSameDay(key, 'startDate', start) && isSameDay(key, 'endDate', end)
  );



// WEBPACK FOOTER //
// ./src/helpers/DatepickerHelper.js